var React = require('react');

function Dryer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M467 0H45C20.187 0 0 20.187 0 45v422c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45V45c0-24.813-20.187-45-45-45zm15 467c0 8.271-6.729 15-15 15H45c-8.271 0-15-6.729-15-15V45c0-8.271 6.729-15 15-15h422c8.271 0 15 6.729 15 15v422z","key":0}),React.createElement("path",{"d":"M256 60C148.192 60 60 148.214 60 256c0 107.808 88.214 196 196 196 107.808 0 196-88.214 196-196 0-107.808-88.214-196-196-196zm0 362c-91.533 0-166-74.467-166-166S164.467 90 256 90s166 74.467 166 166-74.467 166-166 166z","key":1})]);
}

Dryer.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Dryer;

Dryer.default = Dryer;
